<template>
  <div>
    <Breadcrumb msg1="配镜业务" msg2="订单详情" />
    <el-card v-if="order.id">
      <div style="margin-bottom: 10px">
        <el-button icon="el-icon-back" @click="$router.back()">返回</el-button>
      </div>
      <el-descriptions :column="3" border>
        <el-descriptions-item label="订单号">{{ order.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="客户">{{ customerName(order.customerId) }}</el-descriptions-item>
        <el-descriptions-item label="状态">
          <el-tag>{{ order.status }}</el-tag>
        </el-descriptions-item>
        <el-descriptions-item label="镜架">{{ order.frameName }}</el-descriptions-item>
        <el-descriptions-item label="镜片类型">{{ order.lensType }}</el-descriptions-item>
        <el-descriptions-item label="镜片规格">{{ order.lensSpec }}</el-descriptions-item>
        <el-descriptions-item label="OD度数">{{ order.odDegree }}</el-descriptions-item>
        <el-descriptions-item label="OS度数">{{ order.osDegree }}</el-descriptions-item>
        <el-descriptions-item label="瞳距">{{ order.pd }}</el-descriptions-item>
        <el-descriptions-item label="应收金额">¥{{ order.totalAmount }}</el-descriptions-item>
        <el-descriptions-item label="优惠金额">¥{{ order.discountAmount }}</el-descriptions-item>
        <el-descriptions-item label="已收金额">¥{{ order.paidAmount }}</el-descriptions-item>
        <el-descriptions-item label="渠道">{{ order.channel }}</el-descriptions-item>
        <el-descriptions-item label="下单日期">{{ order.orderDate }}</el-descriptions-item>
        <el-descriptions-item label="取件日期">{{ order.takeDate }}</el-descriptions-item>
        <el-descriptions-item label="备注" :span="3">{{ order.remark }}</el-descriptions-item>
      </el-descriptions>
    </el-card>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb'
import { loadCustomerMap, customerName } from '@/utils/customerName'
export default {
  components: { Breadcrumb },
  data () {
    return {
      id: this.$route.params.id,
      order: {}
    }
  },
  created () {
    loadCustomerMap(this.$axios.http)
    this.$axios.http.get(`/glassesOrders/${this.id}`).then(res => {
      if (res.data.status === 200) this.order = res.data.data
    })
  },
  methods: {
    customerName
  }
}
</script>
